import { z } from 'zod'

import { Manager } from '@/types/park/manager'

/** The provider of a product. */
export const Supplier = z.object({
    /** The ID of the supplier. */
    id: z.number().positive(),

    /** The name of the supplier. */
    name: z.string().min(1),

    /** The manager related. */
    client: Manager,

    /** The email of the supplier. */
    email: z.string().email(),

    /** The phone number of the supplier. */
    phone: z.string(),

    /** The address of the supplier. */
    address: z.string(),

    /** The postal code of the supplier. */
    postalCode: z.string(),

    /** The city of the supplier. */
    city: z.string(),

    /** The opening hours of the supplier. */
    opening_hours: z.string().time(),

    /** The closing hours of the supplier. */
    closing_hours: z.string().time(),
})

/** Supplier inside linked objects. */
export const SupplierBinding = Supplier.pick({
    id: true,
    name: true,
    client: true,
})

export type SupplierBinding = z.infer<typeof SupplierBinding>
